import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

const STEPS = [
  { id: 1, label: 'Upload File' },
  { id: 2, label: 'Validate' },
  { id: 3, label: 'Upload Result' },
] as const;

interface BulkUploadStepIndicatorProps {
  currentStep: 1 | 2 | 3;
}

export function BulkUploadStepIndicator({
  currentStep,
}: BulkUploadStepIndicatorProps) {
  return (
    <div className="rounded-xl border bg-white px-4 py-5 sm:px-6">
      <ol className="flex items-center justify-between gap-2">
        {STEPS.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;

          return (
            <li key={step.id} className="flex flex-1 items-center gap-2">
              <div className="flex min-w-0 flex-col items-center gap-2 sm:flex-row sm:items-center">
                <div
                  className={cn(
                    'flex size-8 shrink-0 items-center justify-center rounded-full border text-sm font-semibold transition-colors',
                    isCompleted && 'border-primary bg-primary text-white',
                    isActive &&
                      !isCompleted &&
                      'border-primary bg-primary text-white',
                    !isActive &&
                      !isCompleted &&
                      'border-border bg-white text-muted-foreground'
                  )}
                >
                  {isCompleted ? <Check className="size-4" /> : step.id}
                </div>
                <span
                  className={cn(
                    'hidden text-center text-xs font-medium sm:block sm:text-left sm:text-sm',
                    isActive || isCompleted
                      ? 'text-foreground'
                      : 'text-muted-foreground'
                  )}
                >
                  {step.label}
                </span>
              </div>
              {index < STEPS.length - 1 && (
                <div
                  className={cn(
                    'hidden h-px flex-1 sm:block',
                    step.id < currentStep ? 'bg-primary' : 'bg-border'
                  )}
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
